import React, { useEffect, useState } from "react";
import { useFetchPostedProjectsQuery } from "../../../../services/baseQuery";
import { OvalLoader } from "../../../Common/Loaders";
import { convertTimestampToDate } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { projectStatus } from "../../../../utils";

export default function PostedProjectTable() {
  const navigate = useNavigate();
  const {
    isLoading,
    isError,
    data: postedProjects,
    error,
    isFetching,
  } = useFetchPostedProjectsQuery();

  const handleViewProject = (projectId) => {
    navigate(`/project-details/${projectId}/${projectStatus.POSTED}`);
  };

  return (
    <div
      className="verificationTableContainer"
      style={{ position: "relative", height: "74.2%" }}
    >
      <div
        className="verificationTableRow"
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <div
          style={{ width: "10%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Sr. No.
        </div>
        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Title
        </div>
        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Posted By
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Budget
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Project Deadline
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Proposal Deadline
        </div>

        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          View Details
        </div>
      </div>
      {isLoading ? (
        <OvalLoader visible={true} color="#3366CC" />
      ) : postedProjects?.length < 1 ? (
        <div>no posted projects</div>
      ) : (
        postedProjects?.map((item, i) => (
          <div
            className="verificationTableRow"
            key={i}
            style={{
              backgroundColor: i % 2 === 0 ? "#6b5acd0e" : "#6b5acd1d",
            }}
          >
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {i + 1}
            </div>
            <div
              style={{
                width: "18%",
                height: "100%",
                textDecoration: "underline",
                whiteSpace: "nowrap",
              }}
              className="eachColumn eachTableBody"
            >
              {item.title.slice(0, 25)}
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.uploadedByData.displayName}
            </div>
            <div
              style={{ width: "12%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.budget.from}-{item.budget.to} SAR
            </div>
            <div
              style={{ width: "12%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {convertTimestampToDate(item?.deadline)}
            </div>
            <div
              style={{ width: "12%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {convertTimestampToDate(item?.proposalDeadline)}
            </div>
            {/* <div
          style={{ width: "15%", height: "100%" }}
          className="eachColumn eachTableBody"
        >
          {item.type}
        </div> */}
            <div
              style={{
                width: "18%",
                height: "100%",
                textDecoration: "underline",
                color: "#3366CC",
                cursor: "pointer",
              }}
              className="eachColumn eachTableBody"
              onClick={() => handleViewProject(item.id)}
            >
              View Project
            </div>
          </div>
        ))
      )}
    </div>
  );
}
